export const AUD_MOBILE_REDESIGN_MAINPAGE = 'aud_mobile_bx925_redesign_mainpage_header';
export const AUD_MOBILE_INCREASE_RECS_DEPTH = 'aud_mobile_bx923_increase_recs_depth';
export const NEWBUILDING_ENTRYPOINT = 'newbuilding_mainpage_hub';

export const EXPERIMENTS: string[] = [
  AUD_MOBILE_REDESIGN_MAINPAGE,
  NEWBUILDING_ENTRYPOINT,
  AUD_MOBILE_INCREASE_RECS_DEPTH,
];
